import React from 'react';
import { NavLink } from 'react-router-dom';
import classnames from 'classnames';
import {
  TELEGRAM_LINK,
  WHATSAPP_LINK,
  WHATSAPP_LINK_MOBILE,
} from '@src/constants';
import ProjectNameIconWhite from '@src/assets/images/ProjectNameIconWhite.svg';
import TelegramIcon from '@src/assets/images/TelegramIcon.svg';
import WhatsappIcon from '@src/assets/images/WhatsappIcon.svg';
import PhoneIcon from '@src/assets/images/PhoneIcon.svg';

import BankRussiaIcon from '@images/Footer/bankRussiaIcon.webp';
import BuroIcon from '@images/Footer/buroIcon.webp';
import CloudPaymentsIcon from '@images/Footer/cloudPaymentsIcon.webp';
import MirIcon from '@images/Footer/mirIcon.webp';
import OkbIcon from '@images/Footer/okbIcon.webp';
import ScoristaIcon from '@images/Footer/scoristaIcon.webp';
import AlfaIcon from '@images/Footer/alfaIcon.webp';
import TBankIcon from '@images/Footer/tBankIcon.webp';

import './Footer.scss';

const feedImages = [
  'https://s3-static-budgett-prod.storage.yandexcloud.net/feeds/plain_1x1_008.jpg',
  'https://s3-static-budgett-prod.storage.yandexcloud.net/feeds/plain_1x1_007.jpg',
  'https://s3-static-budgett-prod.storage.yandexcloud.net/feeds/plain_1x1_006.jpg',
  'https://s3-static-budgett-prod.storage.yandexcloud.net/feeds/plain_1x1_005.jpg',
  'https://s3-static-budgett-prod.storage.yandexcloud.net/feeds/meme_1x1_004.jpg',
  'https://s3-static-budgett-prod.storage.yandexcloud.net/feeds/meme_1x1_003.jpg',
  'https://s3-static-budgett-prod.storage.yandexcloud.net/feeds/meme_1x1_002.jpg',
  'https://s3-static-budgett-prod.storage.yandexcloud.net/feeds/meme_1x1_001.jpg',
];

const defendRightsArr = [
  {
    title: 'Банк России',
    list: [
      {
        description: 'Официальный сайт Банка России',
        link: 'https://www.cbr.ru',
      },
      {
        description: 'Интернет-приемная Банка России',
        link: 'https://www.cbr.ru/reception',
      },
      {
        description: 'Реестры субъектов микрофинансирования',
        link: 'https://www.cbr.ru/microfinance/registry',
      },
    ],
  },
  {
    title: 'Финансовый уполномоченный',
    list: [
      {
        description: 'Официальный сайт финансового уполномоченного',
        link: 'https://finombudsman.ru',
      },
      {
        description:
          '119017, г. Москва, Старомонетный пер., дом 3. Тел.: 8 (800) 200-00-10.',
      },
      {
        description:
          'Потребитель финансовых услуг вправе направить обращение Финансовому уполномоченному Российской Федерации.',
      },
    ],
  },
  {
    title: 'СРО “МиР”',
    list: [
      {
        description: 'Официальный сайт СРО “МиР”',
        link: 'https://npmir.ru',
      },
      {
        description:
          '107078, г. Москва, Орликов переулок, дом 5, стр.1, этаж 2, пом. 11. Тел.: +7 (495) 258-87-05, e-mail: info@npmir.ru.',
      },
      {
        withMargin: true,
        description:
          'ООО МКК “Диджитал Мани” является членом Саморегулируемой организации Союз Микрофинансовых Организаций "Микрофинансирование и развитие" с 21.05.2020 г. ',
      },
      {
        description:
          'Регистрационный номер записи в государственном реестре микрофинансовых организаций: №2004150009570 от 20.03.2020 г.',
      },
    ],
  },
  {
    title: 'Контрольные документы',
    list: [
      {
        link: 'https://www.cbr.ru/Queries/XsltBlock/File/90010/13',
        description:
          'Базовый стандарт защиты прав и интересов физических и юридических лиц - получателей финансовых услуг, оказываемых членами саморегулируемых организаций в сфере финансового рынка, объединяющих микрофинансовые организации',
      },
      {
        link: 'https://static.budgett.ru/pdf/базовый_стандарт_совершения_мфо_операций_на_фин_рынке.pdf',
        description:
          'Базовый стандарт совершения микрофинансовой организацией операций на финансовом рынке',
      },
      {
        link: 'https://static.budgett.ru/pdf/базовый_стандарт_по_управлению_рисками.pdf',
        description:
          'Базовый стандарт по управлению рисками микрофинансовых организаций',
      },
      {
        link: 'https://static.budgett.ru/pdf/Устав.pdf',
        description: 'Устав ООО МКК “Диджитал Мани”',
      },
      {
        link: 'https://static.budgett.ru/pdf/пер.состав.pdf',
        description:
          'Персональный состав органов управления ООО МКК “Диджитал Мани”',
      },
    ],
  },
];

const DefendRightItem = (item) => (
  <div className="component-footer__defend-rights__item">
    {/* eslint-disable-next-line react/destructuring-assignment */}
    <p className="component-footer__defend-rights__title">{item.title}</p>
    {/* eslint-disable-next-line react/destructuring-assignment */}
    {item.list.map((childEl, childIndex) =>
      childEl.link ? (
        <a
          // eslint-disable-next-line react/no-array-index-key
          key={`${childIndex}link`}
          href={childEl.link}
          target="_blank"
          className="component-footer__defend-rights__description_hover"
          rel="noreferrer"
        >
          {childEl.description}
        </a>
      ) : (
        <p
          // eslint-disable-next-line react/no-array-index-key
          key={`${childIndex}link`}
          className={`component-footer__defend-rights__description  ${
            // eslint-disable-next-line react/destructuring-assignment
            childEl.withMargin ? 'component-footer__defend-rights__margin' : ''
          }`}
        >
          {childEl.description}
        </p>
      )
    )}
  </div>
);

const partnersArr = [
  {
    title: 'Банк России',
    image: BankRussiaIcon,
    mobile: {
      width: 96,
      height: 24,
    },
    desktop: {
      width: 165,
      height: 42,
    },
  },
  {
    title: 'CloudPayments',
    image: CloudPaymentsIcon,
    mobile: {
      width: 33.7,
      height: 28,
    },
    desktop: {
      width: 65,
      height: 48,
    },
  },
  {
    title: 'SCORISTA',
    image: ScoristaIcon,
    mobile: {
      width: 110.08,
      height: 18,
    },
    desktop: {
      width: 147.11,
      height: 24,
    },
  },
  {
    title: 'Бюро',
    image: BuroIcon,
    mobile: {
      width: 63.78,
      height: 24,
    },
    desktop: {
      width: 90.32,
      height: 34,
    },
  },
  {
    title: 'ОКБ',
    image: OkbIcon,
    mobile: {
      width: 53.56,
      height: 24,
    },
    desktop: {
      width: 68,
      height: 30,
    },
  },
  {
    title: 'МИР',
    image: MirIcon,
    mobile: {
      width: 82.28,
      height: 18,
    },
    desktop: {
      width: 127,
      height: 30,
    },
  },
  {
    title: 'Альфа',
    image: AlfaIcon,
    mobile: {
      width: 119.44,
      height: 24,
    },
    desktop: {
      width: 119.44,
      height: 24,
    },
  },
  {
    title: 'ТБанк',
    image: TBankIcon,
    mobile: {
      width: 81.43,
      height: 24,
    },
    desktop: {
      width: 95.01,
      height: 28,
    },
  },
];

const Footer = () => {
  const openSite = () => {
    /* global jivo_api */
    jivo_api.open();
  };

  const today = new Date();
  const year = today.getFullYear();

  return (
    <footer className={classnames('component-footer')}>
      <div className="Width-Wrapper">
        <div className="component-footer__header-top">
          <a href="/#promo">
            <img
              className="component-footer__header-top__img"
              src={ProjectNameIconWhite}
              alt="Budgett"
            />
          </a>
          <div className="component-footer__header-top__item_links-block">
            <NavLink to="/privacy" className="component-footer__link">
              Политика конфиденциальности
            </NavLink>
            <a
              href="https://budgett.ru/vidy-zaymov/"
              className="component-footer__link"
            >
              Виды займов
            </a>
            <NavLink to="/control-documents" className="component-footer__link">
              Контрольные документы
            </NavLink>
            <NavLink to="/finance-documents" className="component-footer__link">
              Финансовые документы
            </NavLink>
            <NavLink to="/sitemap" className="component-footer__link">
              Карта сайта
            </NavLink>
          </div>
        </div>
        <p className="mobile-copyright">ООО МКК «Диджитал Мани», {year}</p>
        <div className="component-footer__mobile-links-block">
          <NavLink
            to="/privacy"
            className="component-footer__link component-footer__mobile-links-block__item"
          >
            Политика конфиденциальности
          </NavLink>
          <a
            href="https://budgett.ru/vidy-zaymov/"
            className="component-footer__link component-footer__mobile-links-block__item"
          >
            Виды займов
          </a>
          <NavLink
            to="/control-documents"
            className="component-footer__link component-footer__mobile-links-block__item"
          >
            Контрольные документы
          </NavLink>
          <NavLink
            to="/finance-documents"
            className="component-footer__link component-footer__mobile-links-block__item"
          >
            Финансовые документы
          </NavLink>
          <NavLink
            to="/sitemap"
            className="component-footer__link component-footer__mobile-links-block__item"
          >
            Карта сайта
          </NavLink>
        </div>
        <div className="component-footer__header-bottom">
          {feedImages.map((image) => (
            <img
              src={image}
              alt=""
              key={image}
              className="component-footer__feed-image"
            />
          ))}
          <div className="component-footer__header-bottom__item copyright">
            ООО МКК «Диджитал Мани», {year}
          </div>
          <div className="component-footer__header-bottom__item component-footer__header-bottom__item_social-block">
            <p className="component-footer__header-bottom__title">
              Служба поддержки:
            </p>
            <div className="component-footer__header-bottom__wrapper">
              <div className="Jivo-Block" onClick={openSite}>
                {window.innerWidth > 1299 ? 'Онлайн чат' : 'Онлайн'}
              </div>
              <a
                href={TELEGRAM_LINK}
                className="component-footer__social-link"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  className="component-footer__social-link__img"
                  src={TelegramIcon}
                  alt="Telegram"
                />
              </a>
              <a
                href={
                  window.innerWidth > 850 ? WHATSAPP_LINK : WHATSAPP_LINK_MOBILE
                }
                className="component-footer__social-link"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  className="component-footer__social-link__img"
                  src={WhatsappIcon}
                  alt="Whatsapp"
                />
              </a>
              <a
                href="tel:88005559980"
                className="component-footer__social-link"
                target="_blank"
                rel="noreferrer"
              >
                <img
                  className="component-footer__social-link__img"
                  src={PhoneIcon}
                  alt="email"
                />
              </a>
            </div>
          </div>
        </div>
        <p className="component-footer__layerinfo">
          Общество с ограниченной ответственностью Микрокредитная компания
          “Диджитал Мани”, ИНН 5445030457, ОГРН 1195476084968. Расчетный счет:
          40701810423370000004 в филиале "Новосибирский" АО "АЛЬФА-БАНК", БИК:
          045004774, Корреспондентский счёт: 30101810600000000774. Номер в
          Государственном реестре ЦБ 2004150009570, номер в едином реестре СРО
          54 001155. Юридический адрес: 633011, Новосибирская область, город
          Бердск, улица Островского, дом 55, офис 21. Все права защищены. Режим
          работы ООО МКК “Диджитал Мани”: круглосуточно, без выходных и
          праздничных дней (ежедневно с 00:00 до 23:59).
        </p>
        <div className="component-footer__partners-block">
          <div className="component-footer__partners-block__title">
            Наши партнеры:
          </div>
          <div className="component-footer__partners-block__content">
            {partnersArr.map((el) => {
              const inlineStyles = {
                '--widthMobile': `${el.mobile.width}px`,
                '--heightMobile': `${el.mobile.height}px`,
                '--widthDesktop': `${el.desktop.width}px`,
                '--heightDesktop': `${el.desktop.height}px`,
              };

              return (
                <img
                  className={classnames('partnerImage')}
                  style={inlineStyles}
                  src={el.image}
                  width={165}
                  height={48}
                  alt={el.title}
                />
              );
            })}
          </div>
        </div>
        <div className="component-footer__defend-rights">
          <div className="component-footer__defend-rights__two-items">
            {defendRightsArr.slice(0, 2).map((el, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <DefendRightItem key={index} {...el} />
            ))}
          </div>
          {defendRightsArr.slice(2, defendRightsArr.length).map((el, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <DefendRightItem key={index} {...el} />
          ))}
        </div>
        <p className="component-footer__bottomText">
          В соответствии с пп. 24 ч. 4 ст. 5 Федерального закона от 21 декабря
          2013 г. N 353-ФЗ "О потребительском кредите (займе)": заемщики имеют
          право установить в соответствии с Федеральным законом от 30 декабря
          2004 года N 218-ФЗ "О кредитных историях" запрет на заключение с ним
          договоров потребительского кредита (займа), за исключением договоров
          потребительского кредита (займа), обязательства по которым обеспечены
          ипотекой и (или) залогом транспортного средства, а также договоров
          основного образовательного кредита, предоставление государственной
          поддержки по которому осуществляется в порядке, установленном в
          соответствии с частью 4 статьи 104 Федерального закона от 29 декабря
          2012 года N 273-ФЗ "Об образовании в Российской Федерации" (далее -
          запрет), о порядке и способах установления (снятия) запрета, об
          условиях запрета, об обязанности кредитной организации,
          микрофинансовой организации отказать заемщику в заключении договора
          потребительского кредита (займа) при наличии сведений о действующем
          запрете в кредитной истории заемщика, в случае несоответствия
          представленных заемщиком сведений об идентификационном номере
          налогоплательщика, выявленного в рамках проверки, проведенной в
          соответствии с частью 4.1 статьи 7 настоящего Федерального закона, или
          невозможности самостоятельного получения кредитной организацией,
          микрофинансовой организацией в порядке, установленном частью 4.2
          статьи 7 настоящего Федерального закона, сведений об идентификационном
          номере налогоплательщика, принадлежащем заемщику, о случаях, когда
          юридические и физические лица не вправе требовать исполнения заемщиком
          обязательств по договору потребительского кредита (займа) в
          соответствии с частью 6 статьи 13 настоящего Федерального закона, о
          порядке оспаривания в соответствии с частями 4.1-1 и 4.1-2 статьи 8
          Федерального закона от 30 декабря 2004 года N 218-ФЗ "О кредитных
          историях" информации, содержащейся в кредитной истории, о договоре
          потребительского кредита (займа), заключенном с субъектом кредитной
          истории - физическим лицом при наличии действующего запрета (для
          кредитных организаций, микрофинансовых организаций).
        </p>
      </div>
    </footer>
  );
};

export default Footer;
